import { ClientError } from "graphql-request";

export function isNotFound(error: Error): boolean {
	if (!(error instanceof ClientError)) {
		return false;
	}
	const first = error.response.errors?.[0] as
		{ errorType?: string } | undefined;
	return first?.errorType === "NOT_FOUND";
}
